import {Pipe, PipeTransform} from '@angular/core';
import {Product} from "../../pages/portal/services";

@Pipe({
	name: 'productCouponPaymentDate'
})
export class ProductCouponPaymentDatePipe implements PipeTransform {
	transform(product: Product): Date {
		if (product && product?.couponPayments.length > 0) {
			return product.couponPayments
				.map(coupon => coupon.paymentDate)
				.sort((x, y) => x.getMilliseconds() - y.getMilliseconds())[0];
		}

		return null;
	}
}
